// extracted by mini-css-extract-plugin
export var askAiIcon = "_mg-9";
export var container = "_mg-0";
export var groupSeparator = "_mg-a";
export var highlight = "_mg-4";
export var resultIcon = "_mg-5";
export var resultItem = "_mg-7";
export var resultSubtitle = "_mg-3";
export var resultTitle = "_mg-2";
export var resultsList = "_mg-1";
export var searchGroup = "_mg-6";
export var selected = "_mg-8";